import { useEffect, useState } from 'react'
import { BackendPartner, BackendUser, OnboardingQuestion, QuestionAnswer } from 'common/types'
import validator from 'validator'
import { useOnboarding } from 'pages/onboarding/hooks/useOnboarding'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useLocation } from 'react-router-dom'
import { usePartnerApi } from 'hooks/use-partner-api/usePartnerApi'
import { onboardingStoreState } from 'models/onboarding/onboarding.store'

export const useEditProfile = (eventProfile?: boolean, summitProfile?: boolean) => {
  const { pathname } = useLocation()

  const { onboardingQuestions, partnerOnboardingQuestions, completeEditOnboarding } = useOnboarding()
  const { backendUser, backendPartner } = useAuth()
  const {
    editProfileQuestions,
    showPartner,
    setShowPartner,
    setEditProfileQuestions,
    setCompanyEmailError,
  } = onboardingStoreState

  useEffect(() => {
    setShowPartner(pathname.includes('company/'))
  }, [pathname])

  const { getPartnerProfileByName } = usePartnerApi()
  const memberProfileQuestions = (user?: BackendUser, questions?: OnboardingQuestion[]): OnboardingQuestion[] => {
    const result: OnboardingQuestion[] = []
    questions?.map((questionObj) => {
      switch (questionObj.question) {
        case 'First Name': {
          questionObj.page = 1
          questionObj.pageOrder = 1
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'First Name')?.answer
          return result.push(questionObj)
        }
        case 'Last Name': {
          questionObj.page = 1
          questionObj.pageOrder = 2
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Last Name')?.answer
          return result.push(questionObj)
        }
        case 'Gender Identity': {
          questionObj.page = !eventProfile && !summitProfile ? 1 : 50
          questionObj.pageOrder = 3
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Gender Identity')?.answer
          return result.push(questionObj)
        }
        case 'Age Range': {
          questionObj.page = summitProfile ? 2 : 1
          questionObj.pageOrder = 4
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Age Range')?.answer
          return result.push(questionObj)
        }
        case 'Show Country': {
          questionObj.page = 50
          questionObj.pageOrder = 0
          questionObj.displayType = 'switch'
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Show Country')?.answer
          return result.push(questionObj)
        }
        case 'Show Province': {
          questionObj.page = 50
          questionObj.pageOrder = 1
          questionObj.displayType = 'switch'
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Show Province')?.answer
          return result.push(questionObj)
        }
        case 'Show City': {
          questionObj.page = 50
          questionObj.pageOrder = 2
          questionObj.displayType = 'switch'
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Show City')?.answer
          return result.push(questionObj)
        }
        case 'Location': {
          questionObj.page = summitProfile ? 50 : 1
          questionObj.pageOrder = 5
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Location')?.answer
          return result.push(questionObj)
        }
        case 'Headline': {
          questionObj.page = 2
          questionObj.pageOrder = 0
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Headline')?.answer
          questionObj.wordCount = 250
          questionObj.required = summitProfile
          return result.push(questionObj)
        }
        case 'Company Name': {
          questionObj.page = 2
          questionObj.pageOrder = 1
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Company Name')?.answer
          return result.push(questionObj)
        }
        case 'Experience Level': {
          questionObj.page = eventProfile || summitProfile ? 1 : 2
          questionObj.pageOrder = eventProfile || summitProfile ? 6 : 2
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Experience Level')?.answer
          questionObj.required = eventProfile || summitProfile
          return result.push(questionObj)
        }
        case 'Years of experience': {
          questionObj.page = summitProfile ? 1 : 2
          questionObj.pageOrder = summitProfile ? 5 : 3
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Years of experience')?.answer
          return result.push(questionObj)
        }
        case 'Industry': {
          questionObj.page = summitProfile ? 1 : 2
          questionObj.pageOrder = 4
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Industry')?.answer
          return result.push(questionObj)
        }
        case 'Area of Expertise': {
          questionObj.page = eventProfile ? 1 : 2
          questionObj.pageOrder = eventProfile ? 6 : 5
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Area of Expertise')?.answer
          questionObj.required = eventProfile
          return result.push(questionObj)
        }
        case 'Website': {
          questionObj.page = 2
          questionObj.pageOrder = 6
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Website')?.answer
          questionObj.required = false
          return result.push(questionObj)
        }
        case 'Email ': {
          questionObj.page = 2
          questionObj.pageOrder = 7
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Email ')?.answer
          return result.push(questionObj)
        }
        case 'Show Goals': {
          questionObj.page = 3
          questionObj.pageOrder = 0
          questionObj.displayType = 'switch'
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Show Goals')?.answer
          return result.push(questionObj)
        }
        case 'What Do You Want To Accomplish at Obsidi?': {
          questionObj.page = 3
          questionObj.pageOrder = 1
          questionObj.userAnswer = user?.onboardingQuestions?.find(
            x => x.question === 'What Do You Want To Accomplish at Obsidi?'
          )?.answer
          return result.push(questionObj)
        }
        case 'Show Resume': {
          questionObj.page = 2
          questionObj.pageOrder = 7
          questionObj.displayType = 'switch'
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'Show Resume')?.answer
          return result.push(questionObj)
        }
        case 'resume filename': {
          questionObj.page = 55
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'resume filename')?.answer
          return result.push(questionObj)
        }
        case 'resume': {
          questionObj.page = 2
          questionObj.pageOrder = 8
          questionObj.displayType = 'file-resume'
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'resume')?.answer
          return result.push(questionObj)
        }
        case 'avatar': {
          questionObj.page = eventProfile || summitProfile ? 50 : 1
          questionObj.pageOrder = 0
          questionObj.userAnswer = user?.onboardingQuestions?.find(x => x.question === 'avatar')?.answer
          return result.push(questionObj)
        }
        case 'Do You Identify As Being Part Of The Black Community': {
          questionObj.page = 0
          questionObj.userAnswer = user?.onboardingQuestions?.find(
            x => x.question === 'Do You Identify As Being Part Of The Black Community'
          )?.answer
          return result.push(questionObj)
        }
      }
    })
    return result
  }

  const partnerProfileQuestions = (
    company?: BackendPartner,
    questions?: OnboardingQuestion[]
  ): OnboardingQuestion[] => {
    const result: OnboardingQuestion[] = []
    questions?.map((questionObj) => {
      switch (questionObj.question) {
        case 'Logo': {
          questionObj.page = 1
          questionObj.pageOrder = 1
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Logo')?.answer
          return result.push(questionObj)
        }
        case 'Banner': {
          questionObj.page = 1
          questionObj.pageOrder = 2
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Banner')?.answer
          return result.push(questionObj)
        }
        case 'Company Name': {
          questionObj.page = 1
          questionObj.pageOrder = 3
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Company Name')?.answer
          questionObj.wordCount = 75
          return result.push(questionObj)
        }

        case 'Bio Summary': {
          questionObj.page = 1
          questionObj.pageOrder = 4
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Bio Summary')?.answer
          questionObj.wordCount = 500
          return result.push(questionObj)
        }

        case 'Company Email Address': {
          questionObj.page = 1
          questionObj.pageOrder = 5
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Company Email Address')?.answer
          return result.push(questionObj)
        }

        case 'Company Phone Number': {
          questionObj.page = 1
          questionObj.pageOrder = 6
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Company Phone Number')?.answer
          return result.push(questionObj)
        }

        case 'Show Country': {
          questionObj.page = 50
          questionObj.pageOrder = 0
          questionObj.displayType = 'switch'
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Show Country')?.answer
          return result.push(questionObj)
        }
        case 'Show Province': {
          questionObj.page = 50
          questionObj.pageOrder = 1
          questionObj.displayType = 'switch'
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Show Province')?.answer
          return result.push(questionObj)
        }
        case 'Show City': {
          questionObj.page = 50
          questionObj.pageOrder = 2
          questionObj.displayType = 'switch'
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Show City')?.answer
          return result.push(questionObj)
        }
        case 'Show Goals': {
          questionObj.page = 3
          questionObj.pageOrder = 0
          questionObj.displayType = 'switch'
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Show Goals')?.answer
          return result.push(questionObj)
        }
        case 'Location': {
          questionObj.page = 1
          questionObj.pageOrder = 7
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Location')?.answer
          return result.push(questionObj)
        }
        case 'Industry': {
          questionObj.page = 2
          questionObj.pageOrder = 1
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Industry')?.answer
          return result.push(questionObj)
        }
        case 'Area of Expertise': {
          questionObj.page = 2
          questionObj.pageOrder = 2
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Area of Expertise')?.answer
          questionObj.required = true
          return result.push(questionObj)
        }

        case 'Company Website': {
          questionObj.page = 2
          questionObj.pageOrder = 3
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Company Website')?.answer
          questionObj.required = true
          return result.push(questionObj)
        }

        case 'Company Size Classification': {
          questionObj.page = 2
          questionObj.pageOrder = 4
          questionObj.userAnswer = company?.preferences?.find(x => x.question === 'Company Size Classification')?.answer
          questionObj.required = true
          return result.push(questionObj)
        }

        case 'What Do You Want To Accomplish at Obsidi?': {
          questionObj.page = 3
          questionObj.pageOrder = 1
          questionObj.userAnswer = company?.preferences?.find(
            x => x.question === 'What Do You Want To Accomplish at Obsidi?'
          )?.answer
          return result.push(questionObj)
        }
      }
    })
    return result
  }

  const updatedQuestionAnswers = (updatedQuestions: OnboardingQuestion[]): QuestionAnswer[] => {
    const result: QuestionAnswer[] = []

    updatedQuestions?.forEach(questionObj => {
      const questionAnswer: QuestionAnswer = { question: questionObj?.question, answer: questionObj?.userAnswer }
      result.push(questionAnswer)
    })

    return result
  }

  const requiredPageQuestionsAnswered = (
    pageQuestions: OnboardingQuestion[],
    editProfileQuestions: OnboardingQuestion[],
    setEnabled,
    eventProfile?: boolean
  ) => {
    let ready = false
    let count = 0
    let requiredQuestions = []

    for (let i = 0; i < pageQuestions?.length; i++) {
      if (pageQuestions[i].required === true) {
        requiredQuestions.push(pageQuestions[i])
      }
    }
    requiredQuestions?.map((ques) => {
      editProfileQuestions?.map((quesAns) => {
        if (ques?.question === quesAns?.question) {
          if (ques?.options != null && ques?.options[0] === 'location') {
            const items = quesAns?.userAnswer?.split(',')
            if (items?.length === 3 && !items?.includes('') && count + 1 === requiredQuestions?.length) {
              ready = true
            } else if (items?.length === 3 && !items?.includes('') && eventProfile) {
              count = count + 1
            }
          } else if (quesAns?.userAnswer === '' || quesAns?.userAnswer === undefined) {
            ready = false
          } else {
            count = count + 1
          }
        }
        if (count === requiredQuestions?.length) {
          ready = true
        }
      })
    })
    if (requiredQuestions?.length < 1) ready = true
    setEnabled(ready)
  }

  const checkEmailValidity = (text: string) => {
    return validator.isEmail(text)
  }
  const checkUrlValidity = (text: string) => {
    return text ? validator.isURL(text) : false
  }

  /*
    this will return the index of the questionAnswer based on the question passed in
    if the question doesn't exist it will return the length of the userQuestionAnswers array
    */
  const getQuestionIndex = (question: string, profileQuestions: OnboardingQuestion[]): number => {
    let value: number
    profileQuestions?.find((q, index) => {
      if (q.question === question) value = index
    })
    return value
  }

  const getAvatarString = (questions: OnboardingQuestion[]) => {
    const question = questions?.find(x => x.question === 'avatar')
    return question?.userAnswer
  }

  const profileQuestions = () => {
    if (backendUser?.partnerId && showPartner) {
      return partnerProfileQuestions(backendPartner, partnerOnboardingQuestions)
    }
    return memberProfileQuestions(backendUser, onboardingQuestions)
  }

  const isDuplicateCompanyName = async (companyName: string) => {
    const existingCompanyName: string = await getPartnerProfileByName(companyName)
    return existingCompanyName?.length ? true : false
  }

  useEffect(() => {
    setEditProfileQuestions(profileQuestions())
  }, [onboardingQuestions, partnerOnboardingQuestions])

  useEffect(() => {
    const phoneField = editProfileQuestions?.find(q => q?.question === 'Company Phone Number')?.userAnswer
    const emailField = editProfileQuestions?.find(q => q?.question === 'Company Email Address')?.userAnswer

    if (
      emailField &&
      validator.isEmail(emailField) &&
      phoneField?.length >= 10 &&
      validator.isMobilePhone(phoneField)
    ) {
      setCompanyEmailError(false)
    } else {
      setCompanyEmailError(true)
    }
  }, [editProfileQuestions])

  return {
    profileQuestions,
    updatedQuestionAnswers,
    requiredPageQuestionsAnswered,
    checkEmailValidity,
    checkUrlValidity,
    getQuestionIndex,
    getAvatarString,
    completeEditOnboarding,
    isDuplicateCompanyName,
    editProfileQuestions
  } as const
}
